<template>
    <div class="form-group" v-if="transactions.length > 0" v-loading="isBusy">
        <label>Braintree Transactions</label>
        <table class="table table-border" style="width:100%;margin:10px 0">
            <thead>
            <tr>
                <th>Trans ID</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Customer</th>
                <th>Email</th>
                <th>Order</th>
                <th>Type</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="tr in transactions">
                <td>{{ tr.trans_id }}</td>
                <td>{{ tr.settlement_date }}</td>
                <td>{{ tr.amount }}</td>
                <td>{{ tr.customer_id }}</td>
                <td>{{ tr.customer_email }}</td>
                <td>{{ tr.order }}</td>
                <td>{{ tr.transaction_type }}</td>
                <td>
                    <btn css-class="btn btn-xs btn-link" :click="() => unlinkPayment(tr.id)" :icon="'fas fa-unlink'">
                        Unlink
                    </btn>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        transactions: { type: Array, required: true },
    },
    data() {
        return {
            isBusy: false,
        };
    },
    methods: {
        unlinkPayment(transactionId) {
            this.isBusy = true;
            return axios.get(url(`ajax/payments/unlink-btree-transaction/${transactionId}`))
                        .then(response => {
                            this.$emit('unlinked',
                                _.filter(this.transactions, function (tr) { return tr.id !== transactionId; }));
                        })
                        .finally(() => {
                            this.isBusy = false;
                        });
        },
    },
};
</script>
